//
import { none } from '@/services/Helpers'
import { LOGIN_PAGE } from '@/types/router'
import Axios from 'axios'
import router from '@/router'

const clearAuthorizationHeader = () => {
  delete Axios.defaults.headers.common.Authorization

  const echoAuthHeaders = (window as any)?.Echo?.connector?.options?.auth?.headers
  if (echoAuthHeaders) {
    echoAuthHeaders.Authorization = ''
  }
}

const clearAuthenticationArtifacts = () => {
  localStorage.removeItem('id_token')
  localStorage.removeItem('pinia')
  clearAuthorizationHeader()
}

const redirectToLogin = () => {
  router
    .push({
      name: LOGIN_PAGE,
      params: {},
    })
    .catch(none)
}

Axios.defaults.baseURL = import.meta.env.VITE_APP_API_LOCATION
Axios.defaults.headers.common.Accept = 'application/json'

Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error?.response?.status || (error.response.status === 401 && error.response.config.url !== 'auth/logout')) {
      clearAuthenticationArtifacts()
      redirectToLogin()
    }

    return Promise.reject(error)
  },
)

export default Axios
